// extracted by mini-css-extract-plugin
export var activeFilterButton = "_m1-c";
export var backButton = "_m1-4";
export var backIcon = "_m1-5";
export var chevronShortcut = "_m1-6";
export var container = "_m1-1";
export var editor = "_m1-8";
export var editorWrapper = "_m1-7";
export var prefix = "_m1-2";
export var searchIcon = "_m1-3";
export var suffix = "_m1-9";
export var suffixContent = "_m1-a";
export var suffixText = "_m1-b";
export var wrapper = "_m1-0";